export const getPrompts = () => {
    return fetch('/api/v1/generated-topics/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const getEntitiesPrompts = () => {
    return fetch('/api/v1/prompts-from-entities/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};
